import {Component, Input, OnInit} from '@angular/core';
import {Control, ControlPosition, DomUtil, Map} from 'leaflet';
import {BehaviorSubject} from 'rxjs';
import * as L from 'leaflet';

@Component({
  selector: 'app-leaflet-marker-grouping-toggle-control',
  templateUrl: './leaflet-marker-grouping-toggle-control.component.html',
})
export class LeafletMarkerGroupingToggleControlComponent implements OnInit {
  @Input() markerClusterOptions: BehaviorSubject<L.MarkerClusterGroupOptions>;
  constructor() { }

  ngOnInit() {
  }

  toggleMarkerClusterLevel() {
    const mko = this.markerClusterOptions.getValue();
    if (mko.disableClusteringAtZoom === 18) {
      this.markerClusterOptions.next(Object.assign(mko, {disableClusteringAtZoom: 11}));
    } else {
      this.markerClusterOptions.next(Object.assign(mko, {disableClusteringAtZoom: 18}));
    }
  }
}
